export const calculateDiscount = (discountPercentage: number, price: number) =>
  price * (discountPercentage / 100);
